import { BaseService, ErrorResponse } from "../base";
import type { RecoverSecretRequest, RecoverSecretResponse, LoginUserRequest, LoginUserResponse, PatchUserRequest, PatchUserResponse, InviteUserRequest, InviteUserResponse, ActivateUserRequest, SwitchStandortRequest, SwitchStandortResponse } from "./commands";
import type { Benutzer, Teilnehmer } from "./model";

export const ConciergeServiceSymbol = Symbol();

export interface IConciergeService {
    Login(req: LoginUserRequest): Promise<LoginUserResponse | ErrorResponse>
    Logout():void;

    SwitchStandort(req: SwitchStandortRequest): Promise<SwitchStandortResponse | ErrorResponse>;

    InviteUser(req: InviteUserRequest): Promise<InviteUserResponse>;
    ListUsers():Promise<Array<Benutzer> | ErrorResponse>;

    ListTeilnehmer(): Promise<Teilnehmer[] | ErrorResponse>;
    PatchTeilnehmer(teilnehmer: Teilnehmer): Promise<void | ErrorResponse>;
    AddBenutzerToTeilnehmer(teilnehmerId: string, benutzerId: string): Promise<void | ErrorResponse>;
    RemoveBenutzerFromTeilnehmer(teilnehmerId: string, benutzerId: string): Promise<void | ErrorResponse>;

    PatchUser(req: PatchUserRequest): Promise<PatchUserResponse | ErrorResponse>
    DeleteUser(username: string): Promise<void | ErrorResponse>

    GetUserByActivationCode(code: string): Promise<Benutzer>
    ActivateUserByActivationCode(req: ActivateUserRequest): Promise<void>
  }
  
  export class ConciergeService extends BaseService implements IConciergeService {
  
    constructor(baseUri: string, token: string) {
      super(baseUri, token);
    }

    async ActivateUserByActivationCode(req: ActivateUserRequest): Promise<void> {
      await this.Post<Benutzer>('activate', false, req);
    }

    async GetUserByActivationCode(code: string): Promise<Benutzer> {
      return await this.Get<Benutzer>('invite/' + code, false) as Benutzer;
    }

    AddBenutzerToTeilnehmer(teilnehmerId: string, benutzerId: string): Promise<void | ErrorResponse> {
      throw new Error("Method not implemented.");
    }

    RemoveBenutzerFromTeilnehmer(teilnehmerId: string, benutzerId: string): Promise<void | ErrorResponse> {
      throw new Error("Method not implemented.");
    }

    InviteUser(req: InviteUserRequest): Promise<InviteUserResponse> {
      return this.Post<InviteUserResponse>('invite', true, req);
    }

    RecoverSecret(req: RecoverSecretRequest): Promise<RecoverSecretResponse> {
      return this.Post<RecoverSecretResponse>('recover', true, req);
    }
    
    async ListUsers(): Promise<Benutzer[] | ErrorResponse> {
      return this.Get<Benutzer[]>('benutzer', true);
    }

    async ListTeilnehmer(): Promise<Teilnehmer[] | ErrorResponse> {
      return this.Get<Teilnehmer[]>('teilnehmer', true);
    }

    async PatchTeilnehmer(teilnehmer: Teilnehmer): Promise<void | ErrorResponse> {
      return this.Patch('teilnehmer', teilnehmer);
    }
    
    async DeleteUser(username: string): Promise<void | ErrorResponse> {
      return this.Delete(`benutzer/${username}`);
    }

    async PatchUser(req: PatchUserRequest): Promise<ErrorResponse | PatchUserResponse> {
      return this.Patch<PatchUserResponse>('benutzer', req);
    }
  
    async Login(req: LoginUserRequest): Promise<LoginUserResponse | ErrorResponse> {
      var response = this.Post<LoginUserResponse>('login', false, req);
      this.Token = (await response as LoginUserResponse).token
      return response;
    }

    async SwitchStandort(req: SwitchStandortRequest): Promise<SwitchStandortResponse | ErrorResponse> {
      var response = this.Post<SwitchStandortResponse>('switch', true, req);
      this.Token = (await response as SwitchStandortResponse).token
      return response;
    }

    Logout():void{
      this.Token = null;
    }
  }